// extracted by mini-css-extract-plugin
module.exports = {"Tag":"_2kPpiIFL","hasDelete":"_3bvXwUWY","disabledButton":"_3qiSGH18","deleteButton":"_2PxmhDcv","grayTag":"_6ZXQWJ8d"};
    if(module.hot) {
      // 1754514940264
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  